import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/spinner.svg'


const _hoisted_1 = { class: "selections calendar-selections" }
const _hoisted_2 = { class: "inputs" }
const _hoisted_3 = {
  key: 0,
  class: "icon spinner"
}
const _hoisted_4 = {
  key: 0,
  class: "icon spinner"
}
const _hoisted_5 = {
  key: 0,
  class: "icon spinner"
}

import { AvailabilityFilters } from "@/modules/AvailabilityCalendar/models/AvailabilityFilter";
import useVuelidate from "@vuelidate/core";
import { helpers, required, requiredIf } from "@vuelidate/validators";
import { VBtn, VSelect } from "v-ferry-components";
import { computed, reactive } from "vue";
import useCabinsQuery from "../composables/useCabinsQuery";
import SvgIcon from "@/components/base/SvgIcon.vue";

interface Props {
    filters?: AvailabilityFilters;
    isLoadingConfig?: boolean;
    isLoadingUpdate?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarSelections',
  props: {
    filters: {},
    isLoadingConfig: { type: Boolean },
    isLoadingUpdate: { type: Boolean }
  },
  emits: ["updateFilters"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const state = reactive({
    route: "",
    cabin: "",
    vehicle: "",
});

const rules = {
    route: { required: helpers.withMessage("You must select a route", required) },
    cabin: {
        required: helpers.withMessage(
            "You must select either vehicle or room type",
            requiredIf(function () {
                return !state.vehicle;
            }),
        ),
    },
    vehicle: {
        required: helpers.withMessage(
            "You must select either vehicle or room type",
            requiredIf(function () {
                return !state.cabin;
            }),
        ),
    },
};

const v$ = useVuelidate(rules, state);

const route = computed(() => state.route);

const { data: cabins, isLoading } = useCabinsQuery(route);

const submitForm = async () => {
    const isValid = await v$.value.$validate();
    if (!isValid) return;

    emit("updateFilters", state);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SvgIcon, { icon: "carbon/add" }),
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["inputs__dropdown", { 'is-loading': _ctx.isLoadingConfig }])
        }, [
          (_ctx.isLoadingConfig)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "icon__svg"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _createVNode(_unref(VSelect), {
            modelValue: _unref(v$).route.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).route.$model) = $event)),
            options: _ctx.filters?.routes,
            hasError: _unref(v$).route.$error,
            errors: [...new Set(_unref(v$).route.$errors.map((e) => e.$message))],
            label: "Select route"
          }, null, 8, ["modelValue", "options", "hasError", "errors"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["inputs__dropdown room", { 'is-loading': _unref(isLoading) }])
        }, [
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "icon__svg"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _createVNode(_unref(VSelect), {
            modelValue: _unref(v$).cabin.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).cabin.$model) = $event)),
            canDeselect: "",
            options: _unref(cabins),
            hasError: _unref(v$).cabin.$error,
            errors: [...new Set(_unref(v$).cabin.$errors.map((e) => e.$message))],
            noOptionsLabel: 
                            _unref(v$).route.$model === 'SCST'
                                ? 'No cabins available for selected route'
                                : 'Please select a route to view room type options'
                        ,
            label: "Select room type"
          }, null, 8, ["modelValue", "options", "hasError", "errors", "noOptionsLabel"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["inputs__dropdown", { 'is-loading': _ctx.isLoadingConfig }])
        }, [
          (_ctx.isLoadingConfig)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "icon__svg"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _createVNode(_unref(VSelect), {
            modelValue: _unref(v$).vehicle.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).vehicle.$model) = $event)),
            canDeselect: "",
            options: _ctx.filters?.vehicles,
            hasError: _unref(v$).vehicle.$error,
            errors: [...new Set(_unref(v$).vehicle.$errors.map((e) => e.$message))],
            label: "Bring vehicle"
          }, null, 8, ["modelValue", "options", "hasError", "errors"])
        ], 2)
      ]),
      _createVNode(_unref(VBtn), {
        type: "submit",
        isLoading: _ctx.isLoadingUpdate
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Search")
        ])),
        _: 1,
        __: [6]
      }, 8, ["isLoading"])
    ], 32)
  ]))
}
}

})